/* eslint-disable max-len */
module.exports = i18n => ({
  title: i18n.gettext('Cómo comprar'),
  text: {
    first: i18n.gettext('Realizar una compra en'),
    second: i18n.gettext('es muy simple. Sólo sigue estos pasos:'),
  },
});
